// export const  baseUrl = "http://stockimageutilities-dev.eba-agqidtmn.us-east-1.elasticbeanstalk.com"
// export const  baseUrl = "http://localhost:7979"
// DEPRECATED export const baseUrl = "https://cbkq91me79.execute-api.us-east-1.amazonaws.com/main" 
export const baseUrl = "https://r903e2ou44.execute-api.us-east-1.amazonaws.com/main"